import { parseArtifactContentUrl } from '../artifactPage/artifactPageUrl';
import { ARTIFACT_TYPES, MESSAGE_ROLES } from './constants';

const TIME_FORMAT = { hour: 'numeric', minute: '2-digit' };

const toShelfEntry = (block, message) => {
    const parsed = parseArtifactContentUrl(block.content_url);
    if (!parsed) return null;
    return {
        id: parsed.artifactId,
        title: block.title || '',
        contentUrl: block.content_url,
        createdAt: message.createdAt,
        runId: message.runId ?? null,
        time: message.createdAt ? new Date(message.createdAt).toLocaleTimeString([], TIME_FORMAT) : '',
    };
};

export const collectHtmlArtifacts = messages =>
    (messages || [])
        .filter(message => message.role === MESSAGE_ROLES.ASSISTANT && Array.isArray(message.content))
        .flatMap(message =>
            message.content
                .filter(block => block.type === ARTIFACT_TYPES.HTML)
                .map(block => toShelfEntry(block, message))
                .filter(Boolean)
        )
        .reverse();
